import type { ReactNode } from "react";
import { SidebarInset, SidebarProvider } from "~/components/ui/sidebar";
import { AppSidebar } from "~/components/shell/app-sidebar";
import { AppHeader } from "~/components/shell/app-header";

export function OpsShell({ children }: { children: ReactNode }) {
  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset className="min-w-0">
        <AppHeader />
        <main className="flex flex-1 flex-col gap-5 overflow-auto px-4 py-5 md:px-6">{children}</main>
      </SidebarInset>
    </SidebarProvider>
  );
}
